// extracted by mini-css-extract-plugin
export default {"bellContainer":"NotificationsBell_bellContainer__4Mh3d","count":"NotificationsBell_count__FaISt"};